// src/shared/components/HtmlWhitelistRenderer.jsx
import React, { useMemo} from 'react';
import { Box, Typography } from '@mui/material';
import { unified } from 'unified';
import rehypeParse from 'rehype-parse';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import rehypeReact from 'rehype-react';
import * as jsxRuntime from 'react/jsx-runtime';

// 1) Allowed tags from API
const ALLOWED_TAGS = ['h2', 'strong'];

// 2) Sanitization schema permitting only allowed tags
const sanitizeSchema = {
  ...defaultSchema,
  tagNames: ALLOWED_TAGS,
  attributes: {}
};

// 3) Map tags to MUI components
const componentMap = {
  h2: (props) => <Typography variant="h5" component="h2" gutterBottom {...props} />,  
  strong: (props) => <Typography component="strong" sx={{ fontWeight: 'bold',color:"#6E6E6E !important"}} {...props} />
};

/**
 * HtmlWhitelistRenderer
 * - html: string of HTML from API
 * Renders only allowed tags as MUI components
 */
export default function HtmlWhitelistRenderer({ html }) {
  const content = useMemo(() => {
    return unified()
      .use(rehypeParse, { fragment: true })
      .use(rehypeSanitize, sanitizeSchema)
      .use(rehypeReact, {
        ...jsxRuntime,
        components: componentMap
      })
      .processSync(html)
      .result;
  }, [html]);

  return <Box color={"#6E6E6E!important"}>{content}</Box>;
}
